var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ui segment" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v("Title:")]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.getI18n(_vm.dataset.metadata.title, "en")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v("Description:")]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.getI18n(_vm.dataset.metadata.description, "en")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.dataset.objective != null
        ? _c("div", [
            _c("b", [_vm._v("Objective:")]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.getI18n(_vm.dataset.metadata.objective, "en")) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v("Lineage:")]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.getI18n(_vm.dataset.metadata.datasetLineage, "en")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.dataset.metadata.keywords != null
        ? _c(
            "div",
            { staticClass: "ui segment" },
            [
              _c("div", { staticClass: "ui top attached label" }, [
                _vm._v("Keywords:")
              ]),
              _vm._v(" "),
              _vm._l(_vm.dataset.metadata.keywords, function(keyword, index) {
                return _c("div", { key: index }, [
                  _c("div", [
                    _vm._v(_vm._s(_vm.getI18n(keyword.keyword, "en")))
                  ]),
                  _vm._v(" "),
                  keyword.uri != null
                    ? _c("div", [_vm._v(_vm._s(keyword.uri))])
                    : _vm._e()
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataset.metadata.documents != null
        ? _c(
            "div",
            { staticClass: "ui segment" },
            [
              _c("div", { staticClass: "ui top attached label" }, [
                _vm._v("Documents:")
              ]),
              _vm._v(" "),
              _vm._l(_vm.dataset.metadata.documents, function(document, index) {
                return _c("div", { key: index }, [
                  _c("div", [
                    _vm._v(
                      "\n          " + _vm._s(document.type) + " -\n          "
                    ),
                    _c(
                      "a",
                      { attrs: { href: _vm.getI18n(document.url, "en") } },
                      [_vm._v(_vm._s(_vm.getI18n(document.url, "en")))]
                    )
                  ])
                ])
              })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "info circle icon" }),
      _vm._v(" Identification :\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }